var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcSelect',{attrs:{"value":_vm.selectedTimezone,"options":_vm.options,"multiple":false,"clearable":false,"placeholder":_vm.placeholder,"selectable":_vm.isSelectable,"filter-by":_vm.filterBy,"label":"label"},on:{"option:selected":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }